module.exports = __webpack_public_path__ + "img/default_img.08d30b8c.png";